import { useAppSelector } from "../../../state/store"

export const useAppUser = () => useAppSelector((state) => state.user)

export const useIsAuthenticated = () => useAppUser().isAuthenticated

export const useIsAnonymous = () => useAppUser().isAnonymous
